(function () {
  if (window.customElements.get("cb-gallery")) {
    return;
  }

  var SWIPE_THRESHOLD = 50;
  var VERTICAL_CLOSE = 100;

  function preload(src) {
    if (src) {
      var img = new Image();
      img.src = src;
    }
  }

  class CbGallery extends HTMLElement {
    connectedCallback() {
      if (this._initialized) {
        return;
      }

      this.slides = Array.prototype.slice.call(this.querySelectorAll("[data-cb-slide]"));
      this.count = this.slides.length;
      if (this.count === 0) {
        return;
      }

      this._initialized = true;
      this.sectionId = this.getAttribute("data-section-id") || "";
      this.index = 0;
      this.captionEl = this.querySelector("[data-cb-caption]");
      this.counterEl = this.querySelector("[data-cb-counter]");
      this.dotEls = Array.prototype.slice.call(this.querySelectorAll("[data-cb-dot]"));
      this.stage = this.querySelector("[data-cb-stage]");

      window.cbGallery = window.cbGallery || {};
      window.cbGallery[this.sectionId] = this;

      this._bindControls();
      this._buildLightbox();
      this.goTo(0);
    }

    disconnectedCallback() {
      if (this._lightbox && this._lightbox.parentNode) {
        this._lightbox.parentNode.removeChild(this._lightbox);
      }
      if (this._onKey) {
        document.removeEventListener("keydown", this._onKey);
      }
      if (this._onLbMouseMove) {
        document.removeEventListener("mousemove", this._onLbMouseMove);
      }
      if (this._onLbMouseUp) {
        document.removeEventListener("mouseup", this._onLbMouseUp);
      }
      if (this.sectionId && window.cbGallery) {
        delete window.cbGallery[this.sectionId];
      }
    }

    _bindControls() {
      var self = this;
      var prev = this.querySelector("[data-cb-prev]");
      var next = this.querySelector("[data-cb-next]");

      if (prev) {
        prev.addEventListener("click", function (event) {
          event.preventDefault();
          self.prev();
        });
      }
      if (next) {
        next.addEventListener("click", function (event) {
          event.preventDefault();
          self.next();
        });
      }

      this.dotEls.forEach(function (dot) {
        dot.addEventListener("click", function () {
          self.goTo(parseInt(dot.getAttribute("data-index"), 10) || 0);
        });
      });

      this.slides.forEach(function (slide) {
        var img = slide.querySelector("img");
        if (img) {
          img.addEventListener("click", function () {
            self.openLightbox();
          });
        }
      });

      this._bindSwipe(this.stage, {
        onLeft: function () {
          self.next();
        },
        onRight: function () {
          self.prev();
        }
      });

      this._onKey = function (event) {
        var lbOpen = self._lightbox && self._lightbox.classList.contains("is-open");
        if (lbOpen) {
          if (event.key === "Escape") {
            self.closeLightbox();
          } else if (event.key === "ArrowLeft") {
            self.lbPrev();
          } else if (event.key === "ArrowRight") {
            self.lbNext();
          }
          return;
        }
        if (!self.contains(document.activeElement)) {
          return;
        }
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          self.prev();
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          self.next();
        }
      };
      document.addEventListener("keydown", this._onKey);
    }

    _bindSwipe(el, handlers) {
      if (!el) {
        return;
      }
      var startX = null;
      var startY = null;

      el.addEventListener(
        "touchstart",
        function (event) {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      el.addEventListener(
        "touchend",
        function (event) {
          if (startX === null) {
            return;
          }
          var dx = event.changedTouches[0].clientX - startX;
          var dy = event.changedTouches[0].clientY - startY;

          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
            if (dx < 0) {
              handlers.onLeft();
            } else {
              handlers.onRight();
            }
          } else if (handlers.onVertical && Math.abs(dy) > VERTICAL_CLOSE && Math.abs(dy) > Math.abs(dx)) {
            handlers.onVertical(dy);
          }

          startX = null;
          startY = null;
        },
        { passive: true }
      );
    }

    goTo(target) {
      var self = this;
      this.index = (target + this.count) % this.count;

      this.slides.forEach(function (slide, idx) {
        slide.classList.toggle("is-active", idx === self.index);
      });
      this.dotEls.forEach(function (dot, idx) {
        var active = idx === self.index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-selected", active ? "true" : "false");
      });

      this.slides.forEach(function (slide, idx) {
        var video = slide.querySelector("video");
        if (!video) {
          return;
        }
        if (idx === self.index) {
          if (video.hasAttribute("data-cb-autoplay")) {
            var playing = video.play();
            if (playing && playing.catch) {
              playing.catch(function () {});
            }
          }
        } else {
          video.pause();
        }
      });

      var current = this.slides[this.index];
      if (this.captionEl) {
        this.captionEl.textContent = current.getAttribute("data-caption") || "";
      }
      if (this.counterEl) {
        this.counterEl.textContent = this.index + 1 + " / " + this.count;
      }

      this._preloadNeighbors();
      this._syncLightbox();
    }

    next() {
      this.goTo(this.index + 1);
    }

    prev() {
      this.goTo(this.index - 1);
    }

    _isVideo(slide) {
      return !!(slide && slide.hasAttribute("data-cb-video"));
    }

    // Next/previous IMAGE slide, skipping video slides (used by the lightbox,
    // which only shows photos).
    _imageStep(dir) {
      var n = this.count;
      for (var s = 1; s <= n; s++) {
        var idx = (((this.index + dir * s) % n) + n) % n;
        if (!this._isVideo(this.slides[idx])) {
          return idx;
        }
      }
      return this.index;
    }

    lbNext() {
      this.goTo(this._imageStep(1));
    }

    lbPrev() {
      this.goTo(this._imageStep(-1));
    }

    _preloadNeighbors() {
      for (var k = 1; k <= 2; k++) {
        var slide = this.slides[(this.index + k) % this.count];
        if (slide) {
          var img = slide.querySelector("img");
          preload(slide.getAttribute("data-full") || (img && (img.currentSrc || img.src)));
        }
      }
    }

    _buildLightbox() {
      var self = this;
      var lb = document.createElement("div");
      lb.className = "cb-gallery-lightbox";
      lb.setAttribute("role", "dialog");
      lb.setAttribute("aria-modal", "true");
      lb.setAttribute("aria-label", "Image gallery");

      var fontFamily = getComputedStyle(this).getPropertyValue("--cb-caption-font-family");
      if (fontFamily) {
        lb.style.setProperty("--cb-lb-caption-font", fontFamily);
      }

      lb.innerHTML =
        '<button type="button" class="cb-gallery-lightbox__close" aria-label="Close" data-lb-close>×</button>' +
        '<button type="button" class="cb-gallery-lightbox__arrow cb-gallery-lightbox__arrow--prev" aria-label="Previous image" data-lb-prev>‹</button>' +
        '<div class="cb-gallery-lightbox__scroll" data-lb-scroll><img class="cb-gallery-lightbox__img" alt="" data-lb-img></div>' +
        '<button type="button" class="cb-gallery-lightbox__arrow cb-gallery-lightbox__arrow--next" aria-label="Next image" data-lb-next>›</button>' +
        '<div class="cb-gallery-lightbox__bar" aria-live="polite"><span class="cb-gallery-lightbox__caption" data-lb-caption></span><span class="cb-gallery-lightbox__counter" data-lb-counter></span></div>';

      document.body.appendChild(lb);
      this._lightbox = lb;
      this._lbScroll = lb.querySelector("[data-lb-scroll]");
      this._lbImg = lb.querySelector("[data-lb-img]");
      this._lbCaption = lb.querySelector("[data-lb-caption]");
      this._lbCounter = lb.querySelector("[data-lb-counter]");
      this._zoomed = false;

      lb.querySelector("[data-lb-close]").addEventListener("click", function () {
        self.closeLightbox();
      });
      lb.querySelector("[data-lb-prev]").addEventListener("click", function (event) {
        event.stopPropagation();
        self.lbPrev();
      });
      lb.querySelector("[data-lb-next]").addEventListener("click", function (event) {
        event.stopPropagation();
        self.lbNext();
      });
      lb.addEventListener("click", function (event) {
        if (event.target === lb) {
          self.closeLightbox();
        }
      });

      // Tap / click the image to toggle zoom; click around it closes (or zooms out).
      this._lbImg.addEventListener("click", function (event) {
        event.stopPropagation();
        if (self._suppressClick) {
          self._suppressClick = false;
          return;
        }
        self._toggleZoom(event);
      });
      this._lbScroll.addEventListener("click", function (event) {
        if (event.target === self._lbScroll) {
          if (self._zoomed) {
            self._setZoom(false);
          } else {
            self.closeLightbox();
          }
        }
      });

      // Mouse drag to pan when zoomed (desktop). Touch panning is native (overflow: auto).
      this._lbScroll.addEventListener("mousedown", function (event) {
        if (!self._zoomed) {
          return;
        }
        self._panning = true;
        self._panMoved = 0;
        self._panStartX = event.clientX;
        self._panStartY = event.clientY;
        self._panLeft = self._lbScroll.scrollLeft;
        self._panTop = self._lbScroll.scrollTop;
        self._lbScroll.classList.add("is-grabbing");
        event.preventDefault();
      });
      this._onLbMouseMove = function (event) {
        if (!self._panning) {
          return;
        }
        var dx = event.clientX - self._panStartX;
        var dy = event.clientY - self._panStartY;
        self._panMoved = Math.max(self._panMoved, Math.abs(dx) + Math.abs(dy));
        self._lbScroll.scrollLeft = self._panLeft - dx;
        self._lbScroll.scrollTop = self._panTop - dy;
      };
      this._onLbMouseUp = function () {
        if (!self._panning) {
          return;
        }
        self._panning = false;
        self._lbScroll.classList.remove("is-grabbing");
        if (self._panMoved > 5) {
          self._suppressClick = true;
        }
      };
      document.addEventListener("mousemove", this._onLbMouseMove);
      document.addEventListener("mouseup", this._onLbMouseUp);

      this._bindSwipe(lb, {
        onLeft: function () {
          if (self._zoomed) {
            return;
          }
          self.lbNext();
        },
        onRight: function () {
          if (self._zoomed) {
            return;
          }
          self.lbPrev();
        },
        onVertical: function () {
          if (self._zoomed) {
            return;
          }
          self.closeLightbox();
        }
      });
    }

    _toggleZoom(event) {
      this._setZoom(!this._zoomed, event);
    }

    _setZoom(on, event) {
      if (!this._lbScroll) {
        return;
      }
      if (on) {
        var img = this._lbImg;
        var scroll = this._lbScroll;
        var rect = img.getBoundingClientRect();
        var rx = event && event.clientX != null ? (event.clientX - rect.left) / rect.width : 0.5;
        var ry = event && event.clientY != null ? (event.clientY - rect.top) / rect.height : 0.5;
        rx = Math.min(Math.max(rx, 0), 1);
        ry = Math.min(Math.max(ry, 0), 1);
        this._zoomed = true;
        scroll.classList.add("is-zoomed");
        requestAnimationFrame(function () {
          scroll.scrollLeft = rx * scroll.scrollWidth - scroll.clientWidth / 2;
          scroll.scrollTop = ry * scroll.scrollHeight - scroll.clientHeight / 2;
        });
      } else {
        this._zoomed = false;
        this._lbScroll.classList.remove("is-zoomed");
        this._lbScroll.scrollLeft = 0;
        this._lbScroll.scrollTop = 0;
      }
    }

    _syncLightbox() {
      if (!this._lightbox || !this._lightbox.classList.contains("is-open")) {
        return;
      }
      this._setZoom(false);
      var current = this.slides[this.index];
      var img = current.querySelector("img");
      this._lbImg.src = current.getAttribute("data-full") || (img && (img.currentSrc || img.src)) || "";
      this._lbImg.alt = (img && img.alt) || "";
      this._lbCaption.textContent = current.getAttribute("data-caption") || "";
      this._lbCounter.textContent = this.index + 1 + " / " + this.count;

      for (var k = 1; k <= 2; k++) {
        var slide = this.slides[(this.index + k) % this.count];
        if (slide) {
          preload(slide.getAttribute("data-full"));
        }
      }
    }

    openLightbox() {
      if (!this._lightbox) {
        return;
      }
      this._lightbox.classList.add("is-open");
      document.body.style.overflow = "hidden";
      this._syncLightbox();
      var closeBtn = this._lightbox.querySelector("[data-lb-close]");
      if (closeBtn) {
        closeBtn.focus();
      }
    }

    closeLightbox() {
      if (!this._lightbox) {
        return;
      }
      this._setZoom(false);
      this._lightbox.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  }

  window.customElements.define("cb-gallery", CbGallery);
})();
